export default __webpack_public_path__ + "static/media/post-2.1c50a742.png";